
import { PreferencesUtilisateur } from '@/model/preferences-utilisateur/preferences-utilisateur';
import Vue from 'vue';
import { mapActions } from 'vuex';
export default Vue.extend({
  name: 'LoginSuccess',
  methods: {
    ...mapActions({ loadUser: 'user/loadUser', chargePreferenceUtilisateur: 'preferenceUtilisateur/loadPreferenceUtilisateur' })
  },
  created () {
    this.loadUser()
      .then(user => {
        // eslint-disable-next-line no-console
        console.debug('log in', user);

        this.$gtag.event('authentification', {
          action: 'login',
          label: user.username
        });

        return this.chargePreferenceUtilisateur(user.username);
      }).then((preferencesUtilisateur: PreferencesUtilisateur) => {
        this.$router.push(this.$route.query.redirectFrom as string || preferencesUtilisateur.favoritePage || { name: 'main' });
      });
  }
});
